import { render, staticRenderFns } from "./evaluation_committee_commandment.vue?vue&type=template&id=614dab80&scoped=true"
import script from "./evaluation_committee_commandment.vue?vue&type=script&lang=js"
export * from "./evaluation_committee_commandment.vue?vue&type=script&lang=js"
import style0 from "./evaluation_committee_commandment.vue?vue&type=style&index=0&id=614dab80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614dab80",
  null
  
)

export default component.exports